import React from "react";
import "../../styles/footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <p>Shadi Safaee</p>
    </div>
  );
};

export default Footer;
